import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=ad73504e"
import script from "./Panels.vue?vue&type=script&lang=js"
export * from "./Panels.vue?vue&type=script&lang=js"
import style0 from "./Panels.vue?vue&type=style&index=0&id=ad73504e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad73504e')) {
      api.createRecord('ad73504e', component.options)
    } else {
      api.reload('ad73504e', component.options)
    }
    module.hot.accept("./Panels.vue?vue&type=template&id=ad73504e", function () {
      api.rerender('ad73504e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Components/Panels.vue"
export default component.exports